import React from "react";
import { useQuery } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

const SocialMediaMenu = () => {
  const { data } = useQuery({
    queryKey: "getallSoacilmedia",
    queryFn: () =>
      axios.get(`${BASEURL}social-media`).then((res) => {
        return res?.data;
      }),
  });
  return (
    <div>
      <h2 className="footer-heding">Social Media</h2>
      {data?.links?.map((v, i) => {
        return (
          <p
            className={`my-2.5 font-medium flex items-center ${
              v?.status ? "block" : "hidden"
            } cursor-pointer hover:text-white`}
            key={i}
          >
            <span>
              <MdKeyboardDoubleArrowRight className="mr-0.5 w-5 h-5" />
            </span>
            <a href={v?.url} target="_blank">
              {v?.platform}
            </a>
          </p>
        );
      })}
    </div>
  );
};

export default SocialMediaMenu;
